import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/membershipLengthSagas";

export const UpdateBtns = ({ params }) => {
  const dispatch = useDispatch();
  const filtersDirty = useSelector((state) => state.membershipLengthByAgreement.filtersDirty);

  return filtersDirty ? (
    <div className="action-buttons">
      <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
        Update
      </button>
      <button
        className="submit reset"
        onClick={() => dispatch(actionCreators.fetchCurrentUser(params))}
      >
        Reset
      </button>
    </div>
  ) : null;
};
